/**
 * 倒计时 hook —— 收银台支付倒计时(15min,锚 createdAt+15min)等用之。
 * 语义对齐 rn-app `common/hooks/useCountdown.ts`:1s tick,到期自停。
 */
import { useEffect, useState } from 'react';

export interface CountdownResult {
  /** 剩余秒数(>=0)。 */
  secondsLeft: number;
  /** 是否已到期(剩余 <=0;空/非法 expiresAt 视为已到期)。 */
  isExpired: boolean;
}

function compute(expiresAt: string | undefined | null): CountdownResult {
  if (!expiresAt) return { secondsLeft: 0, isExpired: true };
  const ts = Date.parse(expiresAt);
  if (Number.isNaN(ts)) return { secondsLeft: 0, isExpired: true };
  const secs = Math.max(0, Math.floor((ts - Date.now()) / 1000));
  return { secondsLeft: secs, isExpired: secs <= 0 };
}

export function useCountdown(expiresAt: string | undefined | null): CountdownResult {
  const [state, setState] = useState<CountdownResult>(() => compute(expiresAt));

  useEffect(() => {
    setState(compute(expiresAt));
    const next = compute(expiresAt);
    if (next.isExpired) return;
    const timer = setInterval(() => {
      const cur = compute(expiresAt);
      setState(cur);
      if (cur.isExpired) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [expiresAt]);

  return state;
}

/** 秒 → "mm:ss"。 */
export function formatMmSs(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const mm = String(Math.floor(s / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return `${mm}:${ss}`;
}
